import { defineComponent, PropType } from 'vue'
import { BaseCard, ModuleBase, ModuleBaseHeader } from '#components'
import { moduleBaseProps } from '@/components/module/base'
interface EventItem {
  title: string
  image: string
  publish_time: number
  weight: number
  url: string
  display: number // 前端过滤 0 ｜ 1
}
export default defineComponent({
  name: 'ModuleClCommunityMaps',
  props: {
    ...moduleBaseProps,
    title: String,
    list: {
      type: Array as PropType<EventItem[]>,
      default: () => []
    },
    ratio: {
      type: Number,
      default: 16 / 9
    }
  },
  setup(props, { slots }) {
    const eventList = computed(() => {
      return props.list.filter((item) => item.display === 1).sort((a, b) => b.weight - a.weight)
    })
    return () => (
      <ModuleBase name={props.name}>
        <ModuleBaseHeader decoration={false} title={props.title} />
        <div class="mt-2 grid grid-cols-3 gap-4">
          {eventList.value.map((item) => (
            <BaseCard title={item.title} image={item.image} url={item.url} ratio={props.ratio} customInfo={true}>
              <div class="flex items-center bg-[#1b1b1b] px-2.5 py-1">
                <h3 class="capitalize truncate text-xl ...">{item.title}</h3>
              </div>
            </BaseCard>
          ))}
        </div>
      </ModuleBase>
    )
  }
})
